"use client"; // Error boundaries must be Client Components

import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const ErrorPage = (props: ErrorPageProps) => {
  const { error, reset } = props;

  const t = useTranslations("Error");

  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);

  return (
    <div className="flex flex-col items-center justify-items-center min-h-screen p-8 pb-20 gap-16 sm:p-20 font-[family-name:var(--font-geist-sans)]">
      <h1>{t("title")}</h1>
      <h2>{t("description")}</h2>
      <Link href="/">{t("returnHome")}</Link>
    </div>
  );
};

export default ErrorPage;
